// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__X4ee2","inner":"Notice_inner__VAYOw","icon":"Notice_icon__z68fb","title":"Notice_title__vUavc","text":"Notice_text__+ips2"};